import styled from 'styled-components'

import fachadaPng from '../../assets/ART/fachada.webp'

export const Container = styled.div`
  width: 100%;
  background-image: url(${fachadaPng});
  background-size: 100%;
  background-repeat: no-repeat;
`
export const ContainerSwiper = styled.div`
  padding: 8rem 1rem;
`

